function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.4375 8.10938H3.72419L11.932 0.984375C12.0633 0.869531 11.9836 0.65625 11.8101 0.65625H9.73591C9.64451 0.65625 9.55779 0.689062 9.48982 0.747656L0.632789 8.43281C0.551668 8.50313 0.48661 8.59006 0.442023 8.68772C0.397435 8.78537 0.374359 8.89147 0.374359 8.99883C0.374359 9.10618 0.397435 9.21228 0.442023 9.30994C0.48661 9.4076 0.551668 9.49453 0.632789 9.56484L9.54138 17.2969C9.57654 17.3273 9.61873 17.3438 9.66326 17.3438H11.8078C11.9812 17.3438 12.0609 17.1281 11.9297 17.0156L3.72419 9.89062H17.4375C17.5406 9.89062 17.625 9.80625 17.625 9.70312V8.29688C17.625 8.19375 17.5406 8.10938 17.4375 8.10938Z",
  fill: "#4190F7"
});

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.2358c47c.svg";
export { ForwardRef as ReactComponent };